import { Api } from '../../services/http/Api';

type RechargeList = {
    client_code: number;
    client_name: string;
    cod_cli?: string;
    receiving_code: string;
    receiving_name: string;
    cpf: string;
    cnpj: string;
    patient_status?: string;
    patitent_status?: string;
    delivery_address?: string;
    delivery_number?: string;
    delivery_zipcode?: string;
    delivery_city?: string;
    delivery_neighborhood?: string;
    delivery_complement?: string;
    delivery_uf?: string;
    quotaProducts?: unknown[];
    ROWS: number;
};

export class RechargeDataSource {
    async getRecharge(
        page: number,
        pageSize: number,
        cnpj?: string | undefined,
        cpf?: string | undefined
    ) {
        const safe = (v?: string) =>
            !v || v === 'undefined' || v === 'null' ? 'null' : v;

        const result = (await new Api().fetch(
            `/ballast/rechargeList/cnpj/${safe(cnpj)}/cpf/${safe(cpf)}/page/${page}/pageSize/${pageSize}`
        )) as RechargeList;
        return result;
    }
}
